// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Database Manager API
 * API to orchestra resources
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const V1RollStrategy = {
  RollStrategySubtractive: 'subtractive',
  RollStrategyAdditive: 'additive',
  RollStrategyNone: '',
} as const;
export type V1RollStrategy =
  (typeof V1RollStrategy)[keyof typeof V1RollStrategy];

export function instanceOfV1RollStrategy(value: any): boolean {
  for (const key in V1RollStrategy) {
    if (Object.prototype.hasOwnProperty.call(V1RollStrategy, key)) {
      if (V1RollStrategy[key as keyof typeof V1RollStrategy] === value) {
        return true;
      }
    }
  }
  return false;
}

export function V1RollStrategyFromJSON(json: any): V1RollStrategy {
  return V1RollStrategyFromJSONTyped(json, false);
}

export function V1RollStrategyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V1RollStrategy {
  return json as V1RollStrategy;
}

export function V1RollStrategyToJSON(value?: V1RollStrategy | null): any {
  return value as any;
}

export function V1RollStrategyToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): V1RollStrategy {
  return value as V1RollStrategy;
}
